module.exports = __webpack_public_path__ + "static/media/1014904.f1579f62.jpg";